import { getRequired } from "./apiClient";

const images = new Map<string, Promise<string | undefined>>();

export function getMarketingThumbnail(key: string): Promise<string | undefined> {
  if (!/^[a-f0-9]{64}$/.test(key)) return Promise.resolve(undefined);
  let pending = images.get(key);
  if (!pending) {
    if (images.size >= 100) images.delete(images.keys().next().value!);
    pending = getRequired<{ dataUrl?: string }>(`/marketing/content-images/${key}`).then(result => result.dataUrl)
      .catch(error => { images.delete(key); throw error; });
    images.set(key, pending);
  }
  return pending;
}
